export const environment = {
  production: false,
  backendUrl: 'https://test.api.minibite.ch/',
};
